import React from "react"
import BackgroundImage from "gatsby-background-image"

import SEO from "../components/seo"
import Layout from "../components/layout"
import { graphql, Link } from "gatsby"
import HeroImage from "../components/index/heroImage"
import Introduction from "../components/index/introduction"
import Testimonials from "../components/index/testimonials"
import RecentWeddingDayStories from "../components/index/recentWeddingDayStories"
import HowItWorks from "../components/index/howItWorks"

const IndexPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO title="Home" />
      <Layout isThereAHeroImage={true}>
        <HeroImage image={data.heroImage} title="Wedding Photography" subText="For Couples who want to Ditch the stressnd have the best day ever"/>
        <div className="py-5" />
        <Introduction intro1={data.intro1} intro2={data.intro2} />
        <div className="py-5" />
        <Testimonials dataImage={data.testimonialsImage.edges} />
        <div className="py-5" />
        <RecentWeddingDayStories imageData={data.recentWeddingPhoto.edges} />
        <HowItWorks data={data.howItWorksPhoto} />
      </Layout>
    </React.Fragment>
  )
}

export default IndexPage

export const query = graphql`
  {
    heroImage: file(name: { eq: "wedding" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    intro1: file(name: { eq: "photographer" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    intro2: file(name: { eq: "photographer2" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    testimonialsImage: allFile(
      filter: { relativeDirectory: { eq: "indexPage/testimonials" } }
    ) {
      edges {
        node {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    recentWeddingPhoto: allFile(
      filter: { relativeDirectory: { eq: "indexPage/recent" } }
    ) {
      edges {
        node {
          id
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    howItWorksPhoto: file(name: { eq: "howItWorks" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
